module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_galentines-aca616da7e020ca6201cbbbdc8076b6d.jpg";